import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { SessionDetailPage } from '@/features/sessions/session-pages';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

/**
 * Une session interactive : son état et ses cellules (ADR 0042 §5). `?code=` préremplit la cellule
 * (« Ouvrir dans un notebook » d'une table du catalogue) ; rien n'est exécuté sans un clic.
 */
export const Route = createFileRoute('/$tenant/sessions/$sessionId')({
  validateSearch: (search: Record<string, unknown>): { code?: string } => {
    const code = typeof search['code'] === 'string' ? search['code'].slice(0, 10_000) : '';
    return code.trim() ? { code } : {};
  },
  component: SessionRoute,
});

function SessionRoute() {
  const { tenant, sessionId } = Route.useParams();
  const { code } = Route.useSearch();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="sessions"
      crumbs={[
        { label: t('sessions.title') },
        { label: <EntityName tenantId={tenant} kind="session" id={sessionId} /> },
      ]}
    >
      <SessionDetailPage tenantId={tenant} sessionId={sessionId} {...(code ? { initialCode: code } : {})} />
    </ConsoleShell>
  );
}
